import { render, staticRenderFns } from "./InvitedForm.vue?vue&type=template&id=595fca64"
import script from "./InvitedForm.vue?vue&type=script&lang=js"
export * from "./InvitedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports